<div class="composer-wrap">
  <div class="composer">
    <div class="cbox" [class.disabled]="disabled" (click)="focusInput()">
      <div class="crow">
        <textarea #textareaRef rows="1" [disabled]="disabled" [attr.maxlength]="maxLength"
          [placeholder]="'Ask about your monitoring or IH data…' | translate" (input)="onInput()"
        (keydown)="onKeyDown($event)"></textarea>
        <button type="button" class="report-btn" [disabled]="disabled || reportDisabled || !hasContent || charCount > maxLength"
          [matTooltip]="'Generate report' | translate" (click)="onGenerateReportClick()">
          <mat-icon>description</mat-icon>
        </button>
        <button type="button" class="send" [disabled]="disabled || !hasContent || charCount > maxLength" (click)="onSendClick()">
          <mat-icon>send</mat-icon>
        </button>
      </div>
      @if (charCount > maxLength - 500) {
        <span class="char-counter" [class.limit-reached]="charCount >= maxLength">
          {{ charCount }}/{{ maxLength }}
        </span>
      }
    </div>
    <div class="disclaimer">
      <mat-icon>info</mat-icon>
      <span>{{ 'AI-assisted. Answers come only from your LEAP data and your access scope. Verify before regulatory use.' | translate }}</span>
    </div>
  </div>
</div>
